import * as React from "react";

import ImageView, { SmartImageProps } from "../../../../components/SmartImage";
import DiscountInfoCard from "./DiscountInfoCard";
import { BottomViews } from "../BottomViews";
import { PriceViews } from "../PriceViews";
import { NameViews } from "../NameViews";
import { ActTagViewForPc } from "../ActTagViews";
import {
	ProductCardWrap,
	DescriptionWrap,
	ProductCardPoster,
} from "./styles";
import { LinkTargetType, ModuleLayoutStyle } from "../../../../services/playground";
import { TProductElement, PoolExtraInfo, ScoreOption } from "../../../../services/product";
import { transformAParam } from "utils/browser";
import { ShipTo24Hours as ShipTo24HoursBox } from "../ShipTo24Hours";

interface TProductElementEx extends TProductElement{
	pricenum?:string;
	originpricenum?:string
}
export interface ProductCardProps {
	product: TProductElementEx;
	width: string | number;
	posterRatio?: number;
	gridCol: number;
	layoutStyle: ModuleLayoutStyle;
	onClick?: (link?: string) => void;
	placeholderBg: string;
	collectOptions?: ScoreOption;
	smartImageProps?: Partial<SmartImageProps>;
	poolId?: string;
	originPriceBr?: Boolean;
}

export class ProductCard extends React.PureComponent<ProductCardProps, {}> {
	constructor(props: ProductCardProps) {
		super(props);
		this.state = {};
	}

	render() {
		const { product, gridCol, posterRatio = 1, layoutStyle, placeholderBg = "", collectOptions = {}, smartImageProps = {}, poolId, originPriceBr } = this.props;
		const {
			imgOnBottomLeft,
			imgOnTopLeft,
			imgOnTopRight,
			titleIcon,
			collect,
			actTags,
			shipIn24hours,
			flash
		} = product.extra || ({} as PoolExtraInfo);
		const aProps = transformAParam({
			isInApp: false,
			link: product.url,
			aTarget: LinkTargetType.Blank,
			onClick: this.props.onClick,
		});
		return (
			<ProductCardWrap {...aProps} width={this.props.width} id={`${poolId}${product.gpid}`}>
				<ProductCardPoster
					posterRatio={posterRatio}
					layoutStyle={layoutStyle}
					style={{
						background: `url(${placeholderBg}) center`,
						backgroundSize: "cover",
						backgroundRepeat: "no-repeat",
						width: this.props.width,
					}}>
					<DiscountInfoCard
						discountInfo={imgOnTopRight}
						tagInfo={imgOnTopLeft}
						themeTag={imgOnBottomLeft}
						flash={flash}
					/>
					<ImageView
						src={product?.img}
						{...smartImageProps}
						online={true}
						placeholder={placeholderBg}
						fallbackSrc={placeholderBg}
						imgClass={"productImage"}
						fit={true}
					/>
				</ProductCardPoster>

				<DescriptionWrap gridCol={gridCol}>
					<>
						<NameViews
							name={product.name}
							columnNum={actTags ? 1 : 2}
							titleTag={titleIcon?.img || ""}
						/>
						{actTags && <ActTagViewForPc actTags={actTags} />}
						<PriceViews
							className={`priceView${ModuleLayoutStyle.Orange}`}
							price={product.price}
							originPrice={product.originPrice}
							pricenum={product.pricenum}
							originpricenum={product.originpricenum}
							originPriceBr={originPriceBr}
						/>
						{collect && <BottomViews columnNum={gridCol} collect={collect} collectOptions={collectOptions} />}
						{shipIn24hours && <ShipTo24HoursBox text={shipIn24hours} />}
					</>
				</DescriptionWrap>
			</ProductCardWrap>
		);
	}
}
